module.exports = __webpack_public_path__ + "static/media/refresh.92dfafe9.png";